export default __webpack_public_path__ + "static/media/sprite_icon.69882fbb.png";